<section *ngIf="!isSuccess && !isPending">
    <h2>{{ pageData.header }}</h2>
    <div class="loader">
        <div class="addon-loader-percentage">{{ percentage }}%</div>
        <div class="addon-loader-bar">
            <div class="addon-loader-bar-fill" [style.width.%]="percentage"></div>
        </div>
    </div>
    <div class="addon-loader-description">{{ pageData.description }}</div>
</section>

<section *ngIf="isSuccess">
    <h2>{{ pageData.header }}</h2>
    <div class="loader">
        <div class="addon-loader-percentage">{{ percentage }}%</div>
        <div class="addon-loader-bar">
            <div class="addon-loader-bar-fill" [style.width.%]="percentage"></div>
        </div>
    </div>
    <div class="addon-loader-description">{{ pageData.description }}</div>
    <div class="action" *ngIf="pageData.linkCta">
        <a class="xm-btn-link-light description-link" [href]="pageData.link" target="_blank" rel="noopener">{{
            pageData.linkCta }}</a>
    </div>
    <div class="action" *ngIf="pageData.cta">
        <button class="xm-btn-primary-light" [uiSref]="pageData.ctaUiSref"> {{ pageData.cta }} </button>
    </div>
</section>

<section *ngIf="isPending">
    <h2>{{ pageData.header }}</h2>
    <div class="addon-loader-description pending">{{ pageData.description }}</div>
    <div class="disclaimer">
        <xm-media-image aria-hidden="true" class="email-icon" size="height" [imageOptions]="emailIcon"></xm-media-image>
        <cms-text class="disc-text" [originalText]="pageData.disclaimer"></cms-text>
    </div>
    <div class="action" *ngIf="pageData.linkCta">
        <a class="xm-btn-link-light description-link" [href]="pageData.link" target="_blank" rel="noopener">{{
            pageData.linkCta }}</a>
    </div>
    <div class="action" *ngIf="pageData.cta">
        <button class="xm-btn-primary-light" [uiSref]="pageData.ctaUiSref"> {{ pageData.cta }} </button>
    </div>
</section>
